import axios from 'axios'
import { UrlApi } from '../Keys'
import { toast } from 'react-toastify';

const dataInicial = {
    hitos: [],
    loadingHitos: false,
    getHitos: null,
    formacion: [],
    loadingFormacion: false,
    getFormacion: null,
    tareas: [],
    loadingTareas: false,
    getTareas: null,
    hitosActividades: [],
    loadingHitosActividades: false,
    getHitosActividades: null
}

const LOADING_HITOS = 'LOADING_HITOS'
const HITOS = 'HITOS'
const HITOS_ERROR = 'HITOS_ERROR'

const LOADING_FORMACION = 'LOADING_FORMACION'
const FORMACION_DOCENTE = 'FORMACION_DOCENTE'
const FORMACION_DOCENTE_ERROR = 'FORMACION_DOCENTE_ERROR'

const LOADING_TAREAS = 'LOADING_TAREAS'
const TAREAS = 'TAREAS'
const TAREAS_ERROR = 'TAREAS_ERROR'

const LOADING_HITOS_ACTIVIDADES = 'LOADING_HITOS_ACTIVIDADES'
const HITOS_ACTIVIDADES = 'HITOS_ACTIVIDADES'
const HITOS_ACTIVIDADES_ERROR = 'HITOS_ACTIVIDADES_ERROR'

const LIMPIAR_ESTADOS = 'LIMPIAR_ESTADOS'
const LIMPIAR_ACTIVIDADES = 'LIMPIAR_ACTIVIDADES'

export default function asignacionesActividadesReducer(state = dataInicial, action) {
    switch (action.type) {
        case HITOS:
            return { ...state, hitos: action.payload, loadingHitos: action.loadingHitos, getHitos: true }
        case LOADING_HITOS:
            return { ...state, loadingHitos: action.loadingHitos, getHitos: false }
        case HITOS_ERROR:
            return { ...state, loadingHitos: action.loadingHitos, getHitos: true }
        case FORMACION_DOCENTE:
            return { ...state, formacion: action.payload, loadingFormacion: action.loadingFormacion, getFormacion: true }
        case LOADING_FORMACION:
            return { ...state, loadingFormacion: action.loadingFormacion, getFormacion: false }
        case FORMACION_DOCENTE_ERROR:
            return { ...state, loadingFormacion: action.loadingFormacion, getFormacion: true }
        case TAREAS:
            return { ...state, tareas: action.payload, loadingTareas: action.loadingTareas, getTareas: true }
        case LOADING_TAREAS:
            return { ...state, loadingTareas: action.loadingTareas, getTareas: false }
        case TAREAS_ERROR:
            return { ...state, loadingTareas: action.loadingTareas, getTareas: true }
        case HITOS_ACTIVIDADES:
            return { ...state, hitosActividades: action.payload, loadingHitosActividades: action.loadingHitosActividades, getHitosActividades: true }
        case LOADING_HITOS_ACTIVIDADES:
            return { ...state, loadingHitosActividades: action.loadingHitosActividades, getHitosActividades: false }
        case HITOS_ACTIVIDADES_ERROR:
            return { ...state, loadingHitosActividades: action.loadingHitosActividades, getHitosActividades: true }
        case LIMPIAR_ESTADOS:
            return {
                ...state,
                hitos: [],
                loadingHitos: false,
                getHitos: null,
                formacion: [],
                loadingFormacion: false,
                getFormacion: null,
                tareas: [],
                loadingTareas: false,
                getTareas: null,
                hitosActividades: [],
                loadingHitosActividades: false,
                getHitosActividades: null
            }
        case LIMPIAR_ACTIVIDADES:
            return {
                ...state,
                hitosActividades: [],
                loadingHitosActividades: false,
                getHitosActividades: null
            }
        default:
            return { ...state }
    }
}

export const fetchHitos = (token, id) => async (dispatch) => {
    dispatch({
        type: LOADING_HITOS,
        loadingHitos: true
    })

    try {
        var entidad = "new_hitodelaproducciondecontenidos"
        var fetch =
            "<entity name='new_hitodelaproducciondecontenido'>" +
            "<attribute name='new_hitodelaproducciondecontenidoid' />" +
            "<attribute name='new_nombre' />" +
            "<attribute name='statuscode' />" +
            "<attribute name='new_fechavencimiento' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_asignacinproducciondecontenido' operator='eq' value='" + id + "' />" +
            "</filter>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: HITOS,
            payload: response.data,
            loadingHitos: false
        })
    }
    catch (error) {
        dispatch({
            type: HITOS_ERROR,
            loadingHitos: false
        })
    }
}

export const actividadesHitos = (token, id, usuarioPortalRh) => async (dispatch) => {
    dispatch({
        type: LOADING_HITOS_ACTIVIDADES,
        loadingHitosActividades: true
    })

    try {
        var entidad = "new_actividaddelhitos"
        var fetch =
            "<entity name='new_actividaddelhito'>" +
            "<attribute name='activityid' />" +
            "<attribute name='subject' />" +
            "<attribute name='new_ordendentrodelhito' />" +
            "<attribute name='new_cantidaddedias' />" +
            "<attribute name='scheduledstart' />" +
            "<attribute name='actualstart' />" +
            "<attribute name='scheduledend' />" +
            "<attribute name='actualend' />" +
            "<attribute name='new_hitorelacionado' />" +
            "<order attribute='new_ordendentrodelhito' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_hitorelacionado' operator='like' value='" + id + "' />" +
            "</filter>" +
            // "<link-entity name='new_aceptaciondedivision' from='new_aceptaciondedivisionid' to='new_asignaciondocente' link-type='inner' alias='bi'>" +
            // "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='bj'>" +
            // "<filter type='and'>" +
            // "<condition attribute='new_usuarioportalrh' operator='like' value='" + usuarioPortalRh + "' />" +
            // "</filter>" +
            // "</link-entity>" +
            // "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: HITOS_ACTIVIDADES,
            payload: response.data,
            loadingHitosActividades: false
        })
    }
    catch (error) {
        dispatch({
            type: HITOS_ACTIVIDADES_ERROR,
            loadingHitosActividades: false
        })
    }
}

export const fetchFormacion = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_FORMACION,
        loadingFormacion: true
    })

    try {
        var entidad = "new_cursos"
        var fetch =
            "<entity name='new_curso'>" +
            "<attribute name='new_cursoid' />" +
            "<attribute name='new_name' />" +
            "<attribute name='new_grado' />" +
            "<attribute name='new_subdisciplina' />" +
            "<attribute name='cr879_tipodeexperienciadeaprendizaje' />" +
            "<attribute name='new_tipodeformacion' />" +
            "<order attribute='new_name' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_tipodeformacion' operator='in'>" +
            "<value>100000000</value>" +
            "<value>100000001</value>" +
            "</condition>" +
            "</filter>" +
            "<link-entity name='new_formacindocente' from='new_curso' to='new_cursoid' link-type='inner' alias='ak'>" +
            "<attribute name='new_formacindocenteid' />" +
            "<attribute name='new_asignacin' />" +
            "<attribute name='new_curso' />" +
            "<attribute name='statuscode'/>" +
            "<filter type='and'>" +
            "<condition attribute='new_asignacin' operator='eq' value='" + id + "'/>" +
            "<condition attribute='statuscode' operator='in'>" +
            "<value>100000000</value>" +
            "<value>100000004</value>" +
            "<value>100000001</value>" +
            "</condition>" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='new_docente' link-type='inner' alias='al'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "<link-entity name='new_beca' from='new_formacindocente' to='new_formacindocenteid' link-type='outer' alias='am'>" +
            "<attribute name='new_becaid' />" +
            "<filter type='and'>" +
            "<condition attribute='new_tipodebeca' operator='in'>" +
            "<value>100000000</value>" +
            "<value>100000001</value>" +
            "</condition>" +
            "</filter>" +
            "</link-entity>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: FORMACION_DOCENTE,
            payload: response.data,
            loadingFormacion: false
        })
    }
    catch (error) {
        dispatch({
            type: FORMACION_DOCENTE_ERROR,
            loadingFormacion: false
        })
    }
}

export const fetchTareas = (token, id, usuarioPortal) => async (dispatch) => {
    dispatch({
        type: LOADING_TAREAS,
        loadingTareas: true
    })

    try {
        var entidad = "tasks"
        var fetch =
            "<entity name='task'>" +
            "<attribute name='subject' />" +
            "<attribute name='new_materia' />" +
            "<attribute name='activityid' />" +
            "<attribute name='scheduledstart' />" +
            "<attribute name='scheduledend' />" +
            "<order attribute='subject' descending='false' />" +
            "<filter type='and'>" +
            "<condition attribute='new_asignacion' operator='eq' uitype='new_asignaciondeactividades' value='" + id + "' />" +
            "</filter>" +
            "<link-entity name='new_empleado' from='new_empleadoid' to='regardingobjectid' link-type='inner' alias='aa'>" +
            "<filter type='and'>" +
            "<condition attribute='new_correoelectronico' operator='like' value='" + usuarioPortal + "' />" +
            "</filter>" +
            "</link-entity>" +
            "</entity>";

        const response = await axios.post(`${UrlApi}api/consultafetch`,
            {
                "entidad": entidad,
                "fetch": fetch
            },
            {
                headers: {
                    "Authorization": `Bearer ${token}`
                }
            }
        )
        dispatch({
            type: TAREAS,
            payload: response.data,
            loadingTareas: false
        })
    }
    catch (error) {
        dispatch({
            type: TAREAS_ERROR,
            loadingTareas: false
        })
    }
}

export const limpiarEstados = () => async (dispatch) => {
    dispatch({
        type: LIMPIAR_ESTADOS,
      })
};

export const limpiarActividades = () => async (dispatch) => {
    dispatch({
      type: LIMPIAR_ACTIVIDADES,
    })
  }